import React, {useEffect} from 'react';

import {BookmakerActionButton} from "../../odds/bookmaker-action-button/bookmaker-action-button";
import {IntersectionObserver} from "../../intersection-observer/intersection-observer";
import {PredictionVote} from "./prediction.vote";
import styles from "../style/prediction.module.scss";
import classNames from "classnames";
import {PredictionTitle} from "./prediction-title";
import {PredictionAthlete} from "./athlete/prediction-athlete";
import {useBookieClick} from "../../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../app/consts";
import {PartialGameViewModel} from "../../../../domain/partial-game/models/partial-game-view-model";

export const Prediction = ({
                             prediction,
                             controller,
                             isVisible,
                             showOdds,
                             showPrediction,
                             onVoteClick,
                             betsImpressionParams,
                             isAthletePage
                           }) => {
  useEffect(() => {
    isVisible && showPrediction && showPrediction()
  }, [isVisible]);


  const {device, state} = controller;
  const {isSmallView} = device;
  const {gameId, currentLinkModel, isContextualMode, isContextualUsed, isBettingPage, bookieLinkContext} = state
  const shouldRenderActionButton: Boolean = prediction.shouldRenderBookmakerActionButton && showOdds;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    bookieId: prediction?.odds?.bookmaker?.id,
    bookieName: prediction?.odds?.bookmaker?.name,
    urlLink: prediction?.odds?.bookmaker?.actionButton?.link,
    type: prediction?.odds?.lineTypeId,
    hasOdds: prediction.hasOdds,
    entityId: gameId,
    currentLinkModelName: isBettingPage ? null : currentLinkModel?.name,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.cta_button,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER.betNow,
    widget: APP.GOOGLE_ANALYTICS.SOURCES.prediction,
    source: APP.ANALYTICS.SOURCES.predictions,
    isContextual: isContextualMode,
    contextualUsed: isContextualUsed,
    enableVote: prediction.enableVoting,
    isApostas: isBettingPage,
    screen: state.props?.screen ?? APP.ANALYTICS.SCREENS[currentLinkModel?.name],
    bookieLinkContext
  });

  const containerProps = {
    className: classNames(styles.container, {[styles.small_view]: isSmallView},
      {[styles.disable_voting]: !prediction.enableVoting},
      {[styles.two_options]: prediction.hasTwoOption},
      {[styles.single_odd]: prediction.odds?.isSingleOdd},
      {[styles.athlete_page]: isAthletePage},
      {[styles.player_bet]: state.currentContext?.isPlayerBet},
      {[styles.no_bookmaker_action_button]: !shouldRenderActionButton}),
    margin: '0px',
    threshold: 0
  };

  const baseProps = {
    controller,
    prediction
  }

  const voteProps = {
    prediction,
    controller,
    showOdds,
    onVoteClick,
    betsImpressionParams,
    isAthletePage
  }

  const bookmakerActionButtonProps = {
    isSmallView,
    betsImpressionParams,
    controller,
    onClick: onBookieClick,
    bookieHrefModel,
    bookmaker: prediction.odds?.bookmaker,
    shouldRenderActionButton
  };

  return (
    <IntersectionObserver {...containerProps}>
      <PredictionTitle {...baseProps}/>
      <PredictionAthlete {...baseProps}/>
      <PredictionVote {...voteProps}/>
      {
        shouldRenderActionButton ? <BookmakerActionButton {...bookmakerActionButtonProps}/> : null
      }
    </IntersectionObserver>
  )
};
